import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
// import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-enterprise';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RangeSelectionModule } from '@ag-grid-enterprise/range-selection';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { RichSelectModule } from '@ag-grid-enterprise/rich-select';
import { ModuleRegistry } from '@ag-grid-community/core';
import { useSelector, useDispatch } from 'react-redux';
import {
  getAllUserActivity,
  getAuditLogs,
  getAuditLogTotalCount,
  getGridDataByModuleKey,
  getUserList,
} from '../../redux/selector';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import Loader from '../../shared/component/Loader';

import { DateFormatter, DateTimeFormatter } from '../../shared/controls/formatters';

import useFetchIfNeeded from '../../redux/useFetchIfNeeded';
import { auditLogInputData } from '../../shared/constants';
import gridOptionsConfig from '../sharedChild/grid/gridOptionsConfig';
import { useNavigate } from 'react-router-dom';
import { fetchDataAndUpdateStore } from '../../redux/actions';
import { getCommonTextFilterParams } from '../../utils/agGridFilters';
import GlobalSearch from '../sharedChild/grid/globalSearch';
import FilterHandler from '../sharedChild/grid/filterHandler';
// import AddUserForm from './addUserForm';

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  RangeSelectionModule,
  RowGroupingModule,
  RichSelectModule,
]);

function AuditLog() {
  // const themeValue = localStorage.getItem("selectedGridTheme");
  const gridRef = useRef(); // Optional - for accessing Grid's API
  const rowData = useSelector(getAuditLogs);
  const auditLogTotalCount = useSelector(getAuditLogTotalCount);
  const [gridParams, setGridParams] = useState(null);
  const stateData = useSelector((state) => state);
  let storeLoading = isLoadingByKey(stateData, 'auditLogs');
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const gridApiRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState('balham');
  const navigate = useNavigate();
  const gridOptions = gridOptionsConfig('auditLogs', navigate);
  const gridData = useSelector(getGridDataByModuleKey('auditLogs'));
  const dispatch = useDispatch();
  // const commonTextFilterParams = useMemo(() => getCommonTextFilterParams(), []);

  // useFetchIfNeeded(getAuditLogs, fetchDataAndUpdateStore, {
  //     key: 'auditLogs',
  //     inputData: auditLogInputData,
  //   });

  const filterDefaultSetRef = useRef(null);


  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      pinned: 'left',
    };
  }, []);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 150,
    filter: true,
    resizable: true,
    // allow every column to be aggregated
    enableValue: true,
    // allow every column to be grouped
    // enableRowGroup: true,
    // allow every column to be pivoted
    enablePivot: true,
  }));



  const handleGridReady = (params) => {
    gridRef.current = params;
    setGridParams(params);
    const columnOrderFromStore = gridData?.columnState;

    if (columnOrderFromStore) {
      params.columnApi.applyColumnState({
        state: columnOrderFromStore,
        applyOrder: true,
      });
    } else {
      // apply default column visibility if no saved state
      const fieldsToHide = [
        // 'tagIds',
        // 'campaignId',
        // 'createdDateTime',
        // 'updatedDateTime',
        // 'companyLinkedIn',
        // 'website',
        // 'annualRevenue',
        // 'writtenPremium',
        // 'noOfEmployees',
        // 'noOfBeds',
        // 'sourceName',
        // 'otherSourceName',
        // 'salutation',
        // 'firstName',
        // 'middleName',
        // 'lastName',
        // 'revenueType',
        // 'title',
        // 'secondaryEmail',
        // 'mobile',
        // 'directPhone',
        // 'alternatePhone',
        // 'street',
        // 'city',
        // 'emailOptOut',
        // 'state',
        // 'zipCode',
        // 'country',
        // 'description',
        // 'technologyDetails',
      ];

      const defaultState = params.columnApi.getColumnState().map((col) => ({
        ...col,
        hide: fieldsToHide.includes(col.colId),
      }));

      params.columnApi.applyColumnState({
        state: defaultState,
        applyOrder: true,
      });
    }
  };

  const handleFilterChanged = useCallback(
    (event) => {
      if (filterDefaultSetRef.current) {
        filterDefaultSetRef.current = false;
      } else {
        let filterModel = event.api.getFilterModel();

        // Create mappings for campaign names and tag names to their IDs
        const invoiceMapping = {};
        if (rowData?.length) {
          rowData.forEach((item) => {
            invoiceMapping[item.accountName] = item.id;
          });
        }

        const updatedFilterModel = Object.keys(filterModel).reduce((acc, dynamicFilterKey) => {
          let filterData = filterModel[dynamicFilterKey];

          if (dynamicFilterKey === 'campaignId') {
            // Convert campaign names to campaign IDs
            const idValues = filterData.values
              .map((name) => invoiceMapping[name])
              .filter((id) => id !== undefined);

            if (idValues.length > 0) {
              acc[dynamicFilterKey] = {
                filterType: 'text',
                operator: 'OR',
                conditions: idValues.map((id) => ({
                  filterType: 'text',
                  type: 'contains',
                  filter: id, // Ensure we send ID, not name
                })),
              };
            }
          }

          // Keep Other Filters Unchanged
          else {
            acc[dynamicFilterKey] = filterData;
          }

          return acc;
        }, {});

        const payload = {
          ...gridData?.inputPayload,
          filterJson: JSON.stringify(updatedFilterModel),
          pageNumber: 1, // Reset to first page on filter change
        };

        dispatch(
          fetchDataAndUpdateStore({
            key: 'auditLogs',
            inputData: payload,
          })
        );
      }
    },
    [dispatch, gridData?.inputPayload]
  );

  const handleSortChanged = useCallback(
    (event) => {
      const sortModel = event.columnApi
        .getAllDisplayedColumns()
        .map((col) => ({
          colId: col.getColId(),
          sort: col.getSort(),
        }))
        .filter((col) => col.sort);

      console.log('Sort Model:', sortModel);
      const columnName = sortModel.length > 0 ? sortModel[0].colId : 'UpdatedDateTime';
      const orderType = sortModel.length > 0 ? sortModel[0].sort : 'desc';

      const payload = {
        ...gridData?.inputPayload,
        columnName,
        orderType,
        pageNumber: 1, // Reset to first page on sort change
      };

      dispatch(
        fetchDataAndUpdateStore({
          key: 'auditLogs',
          inputData: payload,
        })
      );
    },
    [dispatch, gridData?.inputPayload]
  );

  const popupParent = useMemo(() => {
    return document.body;
  }, []);

  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.paginationGoToPage();
  }, []);
  const cellClickedListener = useCallback((event) => { }, []);
  const isMobile = () => {
    return window.innerWidth <= 767;
  };
  const [columnDefs, setColumnDefs] = useState([
    //   {
    //     headerName: 'Actions',
    //     field: 'actions',
    //     minWidth: 80,
    //     maxWidth: 100,
    //     pinned: 'left',
    //     filter: false,
    //     resizable: false,
    //     cellRenderer: (params) => {
    //       const rowData = { ...params.data, rowIndex: params.rowIndex };
    //       return (
    //         <div className="action-menu">
    //           <i
    //             className="bi bi-three-dots-vertical"
    //             onClick={() => handleOpenModal(rowData)}
    //           />
    //         </div>
    //       );
    //     },
    //   },
    //   {
    //     headerName: 'Id',
    //     field: 'Id',
    //     filter: 'agTextColumnFilter',
    //     minWidth: 260,
    //     filterParams: {
    //       buttons: ['apply', 'reset'],
    //       closeOnApply: true,
    //     },
    //   },
    {
      headerName: 'Correlation Id',
      field: 'correlationId',
      filter: 'agTextColumnFilter',
      type: 'text',
      minWidth: 200,
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
        suppressAndOrCondition: true,
      },
    },
    {
      headerName: 'Request Id',
      field: 'auditableRequestId',
      filter: 'agTextColumnFilter',
      minWidth: 160,
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
        suppressAndOrCondition: true,
      },
    },
    {
      headerName: 'Request Name',
      field: 'auditableRequestName',
      filter: 'agTextColumnFilter',
      minWidth: 180,
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
        suppressAndOrCondition: true,
      },
    },
    {
      headerName: 'Assembly Name',
      field: 'auditableAssemblyQualifiedName',
      filter: 'agTextColumnFilter',
      minWidth: 300,
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
        suppressAndOrCondition: true,
      },
    },
    {
      headerName: 'Source Event',
      field: 'auditableSourceEventName',
      filter: 'agTextColumnFilter',
      minWidth: 200,
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
        suppressAndOrCondition: true,
      },
    },
    {
      headerName: 'API Name',
      field: 'apiName',
      filter: 'agTextColumnFilter',
      minWidth: 180,
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
        suppressAndOrCondition: true,
      },
    },
    {
      headerName: 'Collection Name',
      field: 'collectionName',
      filter: 'agTextColumnFilter',
      minWidth: 180,
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
        suppressAndOrCondition: true,
      },
    },
    {
      headerName: 'Operation Type',
      field: 'operationType',
      filter: 'agTextColumnFilter',
      minWidth: 150,
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
        suppressAndOrCondition: true,
      },
    },
    {
      headerName: 'User Id',
      field: 'userId',
      filter: 'agTextColumnFilter',
      minWidth: 150,
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
        suppressAndOrCondition: true,
      },
    },
    {
      headerName: 'Created Date Time',
      field: 'createdDateTime',
      minWidth: 240,
      valueFormatter: DateTimeFormatter,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Event Data',
      field: 'eventData',
      minWidth: 300,
      filter: false,
      valueFormatter: (params) => (params.value ? JSON.stringify(params.value) : ''),
    },
  ]);

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          // minWidth: 130,
          // width: 130,
          // maxWidth: 130,
          toolPanelParams: {
            suppressPivotMode: true, // 👈 Hide Pivot Mode toggle
            suppressRowGroups: false, // ✅ Allow row grouping
            suppressValues: false, // ✅ Allow aggregation if needed
            suppressPivots: true, // 👈 Hide the pivot section for columns
          },
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          // minWidth: 180,
          // maxWidth: 400,
          // width: 250,
        },
      ].filter(Boolean),
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  return (
    <>
      <div className="inner-page" style={containerStyle}>
        {/* <ToastContainer /> */}
        <div className="dash-container">
          <div className="tbl_container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                <div className="main-hd">
                  <div className="pagetitle">
                    <img src="../assets/images/role-management-icons/left-arrow.png" alt="" />
                    Audit Log
                    <div
                      style={{
                        marginLeft: '80px',
                        fontWeight: 'bold',
                        display: 'flex',
                        gap: '5px',
                        fontSize: '13px',
                      }}
                    ></div>
                  </div>
                  <div className="third-div mobView">
                    <GlobalSearch moduleName={'auditLogs'} />
                  </div>
                </div>

                <div className="cutome_ag_theme">
                  {loading && <Loader />}
                  <div
                    className={`ag-theme-${selectedTheme} tbl_height`}
                    style={{ width: '100%', height: `100%` }}
                  >
                    <AgGridReact
                      className="ag-grid-container" // Add a class for styling
                      // domLayout="autoHeight"
                      domLayout="fixedHeight"
                      ref={gridRef} // Ref for accessing Grid's API
                      rowData={rowData} // Row Data for Row
                      onGridReady={handleGridReady}
                      columnDefs={columnDefs}
                      autoGroupColumnDef={autoGroupColumnDef}
                      defaultColDef={defaultColDef} // Default Column Properties
                      overlayLoadingTemplate={`<Loader />`}
                      animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                      rowSelection={'multiple'} // Options - allows click selection of rows
                      // statusBar={statusBar}
                      enableRangeSelection={true}
                      suppressExcelExport={true}
                      suppressRowClickSelection={true}
                      groupSelectsChildren={true}
                      pivotPanelShow={'always'}
                      popupParent={popupParent}
                      gridOptions={gridOptions}
                      // sortingOrder={sortingOrder}
                      // onFirstDataRendered={onFirstDataRendered}
                      onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                      rowDragManaged={true}
                      suppressMoveWhenRowDragging={true} // to mange the design behaviour during the drag a column.
                      sideBar={sideBar}
                      // onSelectionChanged={onSelectionChanged}
                      alwaysShowVerticalScroll={true}
                      onFilterChanged={handleFilterChanged}
                      onSortChanged={handleSortChanged}
                    />

                    {gridParams && (
                      <FilterHandler
                        params={gridParams}
                        gridData={gridData}
                        columnDefs={columnDefs}
                        filterDefaultSetRef={filterDefaultSetRef}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default AuditLog;
